module.exports = "/cyber/_next/static/images/TabletWidgetPS-18bc4d5510f0dd1e894e85bcf135b993.png";